import { ISequence } from "./sequence";
export class IPairing extends ISequence {
}
//# sourceMappingURL=pairing.js.map